"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var x_data_grid_1 = require("@mui/x-data-grid");
var icons_material_1 = require("@mui/icons-material");
var mountIsland_1 = require("../mountIsland");
var LivestreamAttendanceMap_1 = __importDefault(require("./LivestreamAttendanceMap"));
var LivestreamAttendanceLive = function () {
    var _a, _b, _c;
    var mountEl = document.getElementById('livestream-attendance-live');
    var countries = mountEl
        ? (_b = JSON.parse((_a = mountEl.dataset.countries) !== null && _a !== void 0 ? _a : '{}')) !== null && _b !== void 0 ? _b : {}
        : {};
    var googleKey = mountEl
        ? (_c = mountEl.dataset['google-key']) !== null && _c !== void 0 ? _c : null
        : null;
    var _d = (0, react_1.useState)([]), statistics = _d[0], setStatistics = _d[1];
    var _e = (0, react_1.useState)([]), events = _e[0], setEvents = _e[1];
    var _f = (0, react_1.useState)(''), eventsTitle = _f[0], setEventsTitle = _f[1];
    var _g = (0, react_1.useState)(false), fullscreen = _g[0], setFullscreen = _g[1];
    var _h = (0, react_1.useState)(null), pollInterval = _h[0], setPollInterval = _h[1];
    var filterCountries = function (countryCode) {
        var _a;
        return (_a = countries[countryCode]) !== null && _a !== void 0 ? _a : countryCode;
    };
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get('/api/livestream/statistics/live')];
                    case 1:
                        result = _a.sent();
                        setStatistics(result.data.statistics);
                        setEvents(result.data.events);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        setPollInterval(setInterval(function () {
            fetchData();
        }, 6000));
        var handleBeforeUnload = function () {
            clearInterval(pollInterval);
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
    }, []);
    (0, react_1.useEffect)(function () {
        var title = '';
        for (var i = 0; i < events.length; i++) {
            title += events[i].split(',')[0];
            i < events.length - 1 && (title += ' / ');
        }
        setEventsTitle(title);
    }, [events]);
    var columns = [
        {
            field: 'country',
            headerName: 'Country',
            width: 320,
            valueGetter: function (value) { return filterCountries(value); },
        },
        { field: 'attendance', headerName: 'Attendance', type: 'number' },
    ];
    var rows = statistics.map(function (stat, index) { return ({
        id: index + 1,
        country: stat.country,
        attendance: stat.attendance,
    }); });
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h1" },
                "Live Attendance - ",
                eventsTitle)),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            statistics.length === 0 && (react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.Typography, null, "No live events currently in progress or no attendance data submitted yet"),
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    } },
                    react_1.default.createElement(material_1.CircularProgress, null)))),
            statistics.length > 0 && (react_1.default.createElement(material_1.Button, { variant: "contained", onClick: function () {
                    setFullscreen(true);
                }, startIcon: react_1.default.createElement(icons_material_1.Fullscreen, null) }, "View Fullscreen Map"))),
        fullscreen && (react_1.default.createElement(material_1.Modal, { open: fullscreen, onClose: function () {
                setFullscreen(false);
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: 'white',
                } },
                react_1.default.createElement(material_1.Box, { sx: { position: 'absolute', zIndex: 100, top: 8, right: 8, cursor: 'pointer' }, onClick: function () {
                        setFullscreen(false);
                    } },
                    react_1.default.createElement(icons_material_1.Cancel, null)),
                statistics.length === 0 && react_1.default.createElement(material_1.CircularProgress, null),
                statistics.length > 0 && (react_1.default.createElement(LivestreamAttendanceMap_1.default, { statistics: statistics, title: eventsTitle, googleKey: googleKey }))))),
        statistics.length > 0 && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sx: { alignContent: 'center' } },
            react_1.default.createElement(x_data_grid_1.DataGrid, { rows: rows, columns: columns, autoHeight: true, disableRowSelectionOnClick: true, getRowClassName: function (params) {
                    return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
                }, className: "statistics-table" })))));
};
exports.default = LivestreamAttendanceLive;
var renderElement = document.getElementById('livestream-attendance-live');
if (renderElement) {
    (0, mountIsland_1.mountIsland)(renderElement, react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(LivestreamAttendanceLive, null)));
}
